import { useState } from 'react'
import './AssessmentQue.scss'
import Button from '../button/Button'
import { useEffect } from 'react'
import { useSelector,useDispatch } from 'react-redux';
import { getAssessment } from '../../store/builders/exam-assessment/start-assessment.builder'

function AssessmentQue() {
  const dispatch = useDispatch()
  const {assessment}  = useSelector((state) => state.assessment)

  const [selectedButtons, setSelectedButtons] = useState({})

  const handleButtonClick = (questionId, buttonType) => {
    setSelectedButtons({ ...selectedButtons, [questionId]: buttonType })
  }

  useEffect(() => {
    dispatch(getAssessment("894d2376-45fc-4126-93f7-ed4b9f13aab1"))
}, [])

  return (
    <div className='assessmentQue-main-div'>
      {assessment.map((question,i) => {
        const selectedButton = selectedButtons[question.studentOnlineExamPaperId]
        return (
          <div key={question.studentOnlineExamPaperId} className='assessmentQue'>
            <div className='tab-assessmentQue-number-div'>
              <div className='assessmentQue-number-div'>
                <p>{i+1}</p>
              </div>
              <div className='assessmentQue-question-div'>
                <span>{question.question}</span>
              </div>
            </div>
            <div className='assessmentQue-right'>
              <div className='assessmentQue-answer-div'>
                <div className='answer'>
                  <header>Ans</header>
                  <span>{question.answer}</span>
                </div>
              </div>
              <div className='assessmentAns-btn'>
                <Button
                  variant='contained'
                  customClassName={`btn-incorrect ${selectedButton === 'incorrect' ? 'selected' : ''}`}
                  onClick={() => handleButtonClick(question.studentOnlineExamPaperId, 'incorrect')}
                >
                  Incorrect
                </Button>
                <Button
                  variant='contained'
                  customClassName={`btn-correct ${selectedButton === 'correct' ? 'selected' : ''}`}
                  onClick={() => handleButtonClick(question.studentOnlineExamPaperId, 'correct')}
                >
                  Correct
                </Button>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default AssessmentQue
